import { Instance } from 'mobx-state-tree';
import { CustomerProfileDtoModelBase } from './CustomerProfileDtoModel.base';
import { IStopFormTimeWindow } from '../../../components/orders/OrderForm/orderFormHelpers';

/* The TypeScript type of an instance of CustomerProfileDtoModel */
export interface CustomerProfileDtoModelType extends Instance<typeof CustomerProfileDtoModel.Type> {}

/* A graphql query fragment builders for CustomerProfileDtoModel */
export { selectFromCustomerProfileDto, customerProfileDtoModelPrimitives, CustomerProfileDtoModelSelector } from './CustomerProfileDtoModel.base';

/**
 * CustomerProfileDtoModel
 */
export const CustomerProfileDtoModel = CustomerProfileDtoModelBase
  .views(self => ({
    get durationMinutes(): number | null | undefined {
      if (typeof self.duration === 'number') {
        return parseFloat((self.duration / 60).toFixed(2));
      }
      return self.duration;
    },
    get hasTimeWindow(): boolean {
      return !!(self.timeWindows && self.timeWindows.length > 0);
    },
    get timeWindowObject(): IStopFormTimeWindow | undefined {
      return this.hasTimeWindow ? self.timeWindows?.[0]?.timeWindowObject : undefined;
    },
  }))
  .actions(self => ({
    log() {
      console.log(JSON.stringify(self));
    },
  }));
